import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeactivateSchoolMutationVariables = GraphQLTypes.Exact<{
  unitId: GraphQLTypes.Scalars['String']['input'];
}>;


export type DeactivateSchoolMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'deactivateUnit'>
);


export const DeactivateSchoolDocument = /*#__PURE__*/ gql`
    mutation deactivateSchool($unitId: String!) {
  deactivateUnit(unitId: $unitId)
}
    `;

/**
 * __useDeactivateSchoolMutation__
 *
 * To run a mutation, you first call `useDeactivateSchoolMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSchoolMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateSchoolMutation, { data, loading, error }] = useDeactivateSchoolMutation({
 *   variables: {
 *      unitId: // value for 'unitId'
 *   },
 * });
 */
export function useDeactivateSchoolMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateSchoolMutationResult, DeactivateSchoolMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateSchoolMutationResult, DeactivateSchoolMutationVariables>(DeactivateSchoolDocument, options);
      }
export type DeactivateSchoolMutationHookResult = ReturnType<typeof useDeactivateSchoolMutation>;